/* Expands the review list past the configured cut-off. */
(function () {
  function init() {
    document.querySelectorAll('[data-sv-reviews-more]').forEach(function (button) {
      if (button.dataset.svBound === 'true') return;
      button.dataset.svBound = 'true';

      button.addEventListener('click', function () {
        var section = button.closest('.savendo-reviews');
        if (!section) return;
        section.querySelectorAll('.sv-review--overflow').forEach(function (review) {
          review.classList.remove('sv-review--overflow');
        });
        button.remove();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
